import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { colors, layout } from '../theme/tokens';

/* Page body inside the account shell: light page background with the standard gutters. Centered and
   capped at layout.contentMaxWidth on wide screens (single-column pages; the customer dashboard doesn't
   use this and stays full width). */
export const PageContainer: React.FC<{ isMobile?: boolean }> = ({ isMobile = false, children }) => (
    <Box sx={{ px: isMobile ? 1.5 : 3, py: isMobile ? 1.5 : 2.5, display: 'flex', flexDirection: 'column', gap: 2, maxWidth: layout.contentMaxWidth, mx: 'auto', boxSizing: 'border-box' }}>
        {children}
    </Box>
);

interface PageSectionProps {
    title?: React.ReactNode;
    actions?: React.ReactNode;
    padding?: number;
}

/* White card with an optional title row; the main building block of every account page. */
export const PageSection: React.FC<PageSectionProps> = ({ title, actions, padding = 2.5, children }) => (
    <Paper variant="outlined" sx={{ borderColor: colors.dividerBlue, borderRadius: 2, p: padding }}>
        {(title || actions) && (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 2 }}>
                {title && (
                    <Typography component="h2" sx={{ fontSize: 16, fontWeight: 600, color: colors.titleBlue }}>
                        {title}
                    </Typography>
                )}
                {actions && <Box sx={{ display: 'flex', gap: 1 }}>{actions}</Box>}
            </Box>
        )}
        {children}
    </Paper>
);
